import { Link } from "react-router-dom";
import type { LegendStory } from "@/mocks/stories";

const verdictStyles: Record<LegendStory["verdict"], string> = {
  "有据可考": "text-amberlight-300 border-amberlight-400/40 bg-amberlight-400/10",
  "有历史原型": "text-parchment-200 border-night-500/50 bg-night-600/30",
  "证据不足存疑": "text-cinnabar-300 border-cinnabar-400/40 bg-cinnabar-500/10",
  "基本可证为误传": "text-parchment-300/80 border-night-500/40 bg-night-600/20",
};

export default function LegendCard({ story }: { story: LegendStory }) {
  return (
    <Link
      to={`/story/${story.id}`}
      className="group relative flex flex-col overflow-hidden rounded-lg border border-night-600/50 bg-night-850 transition hover:border-amberlight-500/50"
    >
      <div className="relative aspect-[16/10] overflow-hidden">
        <img
          src={story.cover}
          alt={story.title}
          title={story.title}
          className="h-full w-full object-cover object-center transition duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-night-850 via-transparent to-transparent"></div>
        <span className="absolute left-3 top-3 whitespace-nowrap rounded-full border border-parchment-200/25 bg-night-900/70 px-3 py-1 text-xs text-parchment-100 backdrop-blur">
          {story.category}
        </span>
      </div>
      <div className="flex flex-1 flex-col p-5">
        <h3 className="serif-head text-lg font-bold leading-snug text-parchment-100 transition group-hover:text-amberlight-300">
          {story.title}
        </h3>
        <p className="mt-2.5 line-clamp-2 text-sm leading-relaxed text-parchment-300/70">{story.excerpt}</p>
        <div className="mt-4 flex flex-wrap items-center gap-2 pt-1">
          <span
            className={`whitespace-nowrap rounded-full border px-2.5 py-0.5 text-[11px] ${verdictStyles[story.verdict]}`}
          >
            结论：{story.verdict}
          </span>
          <span className="flex items-center gap-1 whitespace-nowrap text-xs text-parchment-300/60">
            <i className="ri-time-line"></i>
            {story.readTime}
          </span>
        </div>
        <span className="mt-4 inline-flex items-center gap-1 text-sm text-amberlight-400">
          阅读求证
          <i className="ri-arrow-right-line transition group-hover:translate-x-1"></i>
        </span>
      </div>
    </Link>
  );
}